import { message } from 'antd';
import { axiosApi } from '../axios-api';
import { getUserLocalStorage } from '../helpers';

export async function patchCancelBillingSubscription(organizationId) {
  const { data } = await axiosApi.patch(`v2/billing/${organizationId}/subscription/`, {});
  return data;
}

export async function putBillingSubscriptionPlan(organizationId, planId) {
  await axiosApi.put(`v2/billing/${organizationId}/subscription/`, { new_plan: planId });
}

export async function fetchBillingPlansForOrganization(setLoading, organizationId) {
  try {
    if (setLoading) {
      setLoading(true);
    }

    const isRuRegion = getUserLocalStorage('ru_region');

    const data = [];

    if (!isRuRegion) {
      const response = await axiosApi.get('v2/billing/default-price-plans/');
      data.push(...response.data);
    }

    if (organizationId) {
      const customPlansData = await axiosApi.get(`v2/billing/price-plans/?id__in=${organizationId}`);
      const additionalPlans = customPlansData.data[0];
      if (additionalPlans?.custom_plans.length) {
        data.push(...additionalPlans.custom_plans);
      }
    }

    return data;
  } catch (error) {
    if (error.isAxiosError) {
      return message.warning({
        content: error.message,
        duration: 3,
      });
    }
    throw new Error(error);
  } finally {
    if (setLoading) {
      setLoading(false);
    }
  }
}

export async function patchBillingPaymentLink(organizationId, pricePlan) {
  try {
    const { data } = await axiosApi.patch(`v2/billing/${organizationId}/payment-link/`, {
      price_plan: pricePlan,
    });
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}

export async function fetchBillingPaymentMethodLink(organizationId) {
  try {
    const { data } = await axiosApi.get(`v2/billing/${organizationId}/payment-method/`);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}

export async function patchBillingDefaultPaymentMethod(organizationId, paymentMethodId) {
  try {
    const { data } = await axiosApi.patch(
      `v2/billing/${organizationId}/default-payment-method/`,
      { payment_method: paymentMethodId },
    );
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}

export async function deleteBillingPaymentMethod(organizationId, paymentMethodId) {
  try {
    await axiosApi.delete(`v2/billing/${organizationId}/default-payment-method/`, {
      data: { payment_method: paymentMethodId },
    });
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: 'Payment method deleting finished with error',
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}

export async function fetchBillingMonthlyReports(organizationId) {
  try {
    const suffix = organizationId ? `?id__in=${organizationId}` : '';
    const { data } = await axiosApi.get(`v2/billing/monthly-reports/${suffix}`);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: `Something went wrong! ${error.message}`,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}
